import React, {ChangeEvent} from 'react';
import {Button,Row,Col} from 'antd';
import { HasResource } from '../../../../../components/HasResource';
import { ResourceCode } from 'constants/resourceCodes';
import InputFilterItem from "../../../../delivery/components/InputFilterItem";
import ParcelFilterStyle from "../../../../delivery/components/ParcelFilterStyle";
import DateRangeFilterItem from "../../../../delivery/components/DateRangeFilterItem";
import {activeStatusOptions,timezoneOptions} from "./config/filterOptions";
import {PricingSchemeApplyFilterType} from './graphql/types/PricingSchemeApplyType';
import { ChannelSelectFilter } from '../../../../../components/settlement/ChannelSelectFilter';
import type { SelectOptionType } from 'graphql/types/SelectOptionType';

interface PricingSchemeApplyFilterProps {
    filters: PricingSchemeApplyFilterType;
    setFilters: (filters: PricingSchemeApplyFilterType) => void;
    handleFilter: () => void;
    handleResetFilters: () => void;
    showBindDrawer: () => void;
    showUnBindDrawer: () => void;
    operatorOptions: SelectOptionType[];
    operatorOptionsLoading: boolean;
}

const PricingSchemeApplyFilter: React.FC<PricingSchemeApplyFilterProps> = ({
    filters,
    setFilters,
    handleFilter,
    handleResetFilters,
    showBindDrawer,
    showUnBindDrawer,
    operatorOptions,
    operatorOptionsLoading
}) => {

    // 处理时间变化的函数
    const handleBindTimeChange = (
        dates: [string | null, string | null] | null
    ) => {
        setFilters({...filters, bindTime: dates});
    };

    const handleEffectiveTimeChange = (
        dates: [string | null, string | null] | null
    ) => {
        setFilters({...filters, effectiveTime: dates});
    };

    return (
        <div className="mb-6">
            <div className="grid grid-cols-3 gap-x-4 gap-y-3 mb-4">
                <ChannelSelectFilter
                    label="客户名称"
                    value={filters.clientId ?? undefined}
                    onChange={(value: string | undefined) => setFilters({...filters, clientId: value})}
                    spanClassName="w-[9em]"
                />

                <InputFilterItem
                    label="方案ID"
                    value={filters.pricingSchemeId ?? undefined}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({
                        ...filters,
                        pricingSchemeId: e.target.value || undefined
                    })}
                    spanClassName="w-[9em]"
                />

                <ParcelFilterStyle
                    label="操作人"
                    options={operatorOptions}
                    value={filters.operatorId ?? undefined}
                    onChange={(value: string) => setFilters({
                        ...filters,
                        operatorId: value || undefined
                    })}
                    disabled={operatorOptionsLoading}
                    spanClassName="w-[9em]"
                />

                <DateRangeFilterItem
                    label="操作绑定时间"
                    value={filters.bindTime}
                    onChange={handleBindTimeChange}
                    spanClassName="w-[9em]"
                />

                <DateRangeFilterItem
                    label="方案生效时间"
                    value={filters.effectiveTime}
                    onChange={handleEffectiveTimeChange}
                    spanClassName="w-[9em]"
                />

                <ParcelFilterStyle
                    label="时区"
                    options={timezoneOptions}
                    value={filters.timezone ?? undefined}
                    onChange={(value: string) => setFilters({...filters, timezone: value ? value : undefined})}
                    spanClassName="w-[9em]"
                />

                 <ParcelFilterStyle
                    label="生效状态"
                    options={activeStatusOptions}
                    value={filters.activeStatus ?? undefined}
                    onChange={(value: string) => setFilters({...filters, activeStatus: value ? value : undefined})}
                    spanClassName="w-[9em]"
                />
                <InputFilterItem
                    label="绑定维度"
                    value={filters.bindValue ?? undefined}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({
                        ...filters,
                        bindValue: e.target.value || undefined
                    })}
                    spanClassName="w-[9em]"
                />
            </div>
             <Row gutter={[8, 18]}>
                <Col span={24} >
                    <Row justify="end">
                        <Col>
                            <div className="flex gap-4">
                                <HasResource resourceCodes={[ResourceCode.settlement.SETTLEMENT_REVENUE_PRICE_APPLY_OPERATE]}>
                                    <Button
                                        type="primary"
                                        onClick={showBindDrawer}
                                    >
                                        方案绑定
                                    </Button>
                                </HasResource>

                                <HasResource resourceCodes={[ResourceCode.settlement.SETTLEMENT_REVENUE_PRICE_APPLY_OPERATE]}>
                                    <Button
                                        type="primary"
                                        onClick={showUnBindDrawer}
                                    >
                                        方案解绑
                                    </Button>
                                </HasResource>

                                <HasResource resourceCodes={[ResourceCode.settlement.SETTLEMENT_REVENUE_PRICE_APPLY_CHECK]}>
                                    <Button
                                        type="primary"
                                        onClick={handleFilter}
                                    >
                                        筛选
                                    </Button>
                                </HasResource>
                                <HasResource resourceCodes={[ResourceCode.settlement.SETTLEMENT_REVENUE_PRICE_APPLY_CHECK]}>
                                    <Button
                                        type="default"
                                        onClick={handleResetFilters}
                                    >
                                        重置
                                    </Button>
                                </HasResource>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default PricingSchemeApplyFilter;

